module.exports = __webpack_public_path__ + "img/character-random-bg.1c1778f5.webp";